// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FeatureFlagsQueryVariables = Types.Exact<{
  filter: Types.FeatureFlagFilter;
}>;


export type FeatureFlagsQuery = { __typename?: 'Query', featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, createdAt: Types.Scalars['DateTime']['input'], description: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], releaseVersion: number, status: { __typename?: 'FeatureFlagStatusDetail', code: Types.FeatureFlagStatus, name: string }, type: { __typename?: 'FeatureFlagTypeDetail', description: string, code: Types.FeatureFlagType, name: string, presentational: boolean }, targets: Array<{ __typename?: 'FeatureFlagTarget', id: string, target?: { __typename: 'Development', id: string, name: string } | { __typename: 'StandaloneProject', id: string, name: string } | { __typename: 'Region', id: string, name: string } | { __typename: 'Market', id: string, name: string } | { __typename: 'Community', id: string, name: string } | { __typename: 'Subdivision', id: string, name: string } | { __typename: 'Lot', id: string, name: string } | { __typename: 'Structure', id: string, name: string } | { __typename: 'Unit', id: string, name: string } | { __typename: 'User', userId: string, name: string, _id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined } | { __typename: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined }> } | null | undefined }> }> };

export type FeatureFlagsMetadataQueryVariables = Types.Exact<{
  all?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type FeatureFlagsMetadataQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } }>, userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, availableFeatureFlagTypes: Array<{ __typename?: 'FeatureFlagTypeDetail', code: Types.FeatureFlagType, name: string, description: string, presentational: boolean }> };

export type SaveFeatureFlagMutationVariables = Types.Exact<{
  input: Types.SaveFeatureFlagInput;
}>;


export type SaveFeatureFlagMutation = { __typename?: 'Mutation', saveFeatureFlag: { __typename?: 'SaveFeatureFlagResult', featureFlag: { __typename?: 'FeatureFlag', id: string, createdAt: Types.Scalars['DateTime']['input'], description: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], releaseVersion: number, status: { __typename?: 'FeatureFlagStatusDetail', code: Types.FeatureFlagStatus, name: string }, type: { __typename?: 'FeatureFlagTypeDetail', description: string, code: Types.FeatureFlagType, name: string, presentational: boolean }, targets: Array<{ __typename?: 'FeatureFlagTarget', id: string, target?: { __typename: 'Development', id: string, name: string } | { __typename: 'StandaloneProject', id: string, name: string } | { __typename: 'Region', id: string, name: string } | { __typename: 'Market', id: string, name: string } | { __typename: 'Community', id: string, name: string } | { __typename: 'Subdivision', id: string, name: string } | { __typename: 'Lot', id: string, name: string } | { __typename: 'Structure', id: string, name: string } | { __typename: 'Unit', id: string, name: string } | { __typename: 'User', userId: string, name: string, _id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined } | { __typename: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined }> } | null | undefined }> } } };

export type FeatureFlagDetailsFragment = { __typename?: 'FeatureFlag', id: string, createdAt: Types.Scalars['DateTime']['input'], description: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], releaseVersion: number, status: { __typename?: 'FeatureFlagStatusDetail', code: Types.FeatureFlagStatus, name: string }, type: { __typename?: 'FeatureFlagTypeDetail', description: string, code: Types.FeatureFlagType, name: string, presentational: boolean }, targets: Array<{ __typename?: 'FeatureFlagTarget', id: string, target?: { __typename: 'Development', id: string, name: string } | { __typename: 'StandaloneProject', id: string, name: string } | { __typename: 'Region', id: string, name: string } | { __typename: 'Market', id: string, name: string } | { __typename: 'Community', id: string, name: string } | { __typename: 'Subdivision', id: string, name: string } | { __typename: 'Lot', id: string, name: string } | { __typename: 'Structure', id: string, name: string } | { __typename: 'Unit', id: string, name: string } | { __typename: 'User', userId: string, name: string, _id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined } | { __typename: 'UserGroup', id: string, name: string, users: Array<{ __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } } | null | undefined }> } | null | undefined }> };

export type InternalUserDataFragment = { __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string, userId: string } };

export const InternalUserDataFragmentDoc = gql`
    fragment InternalUserData on InternalUser {
  id
  name
  avatar
  user {
    id
    userId
  }
}
    `;
export const FeatureFlagDetailsFragmentDoc = gql`
    fragment FeatureFlagDetails on FeatureFlag {
  id
  createdAt
  description
  status {
    code
    name
  }
  type {
    description
    code
    name
    presentational
  }
  name
  updatedAt
  releaseVersion
  targets {
    id
    target {
      __typename
      ... on User {
        _id: id
        userId
        name
        internalUser {
          ...InternalUserData
        }
      }
      ... on UserGroup {
        id
        name
        users {
          id
          internalUser {
            ...InternalUserData
          }
        }
      }
      ... on Development {
        id
        name
      }
      ... on Project {
        id
        name
      }
    }
  }
}
    ${InternalUserDataFragmentDoc}`;
export const FeatureFlagsDocument = gql`
    query FeatureFlags($filter: FeatureFlagFilter!) {
  featureFlags(filter: $filter) {
    ...FeatureFlagDetails
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables> & ({ variables: FeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
// @ts-ignore
export function useFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export function useFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureFlagsQuery | undefined, FeatureFlagsQueryVariables>;
export function useFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagsSuspenseQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const FeatureFlagsMetadataDocument = gql`
    query FeatureFlagsMetadata($all: Boolean) {
  internalUsers {
    ...InternalUserData
  }
  userGroups {
    id
    name
    users {
      id
      internalUser {
        ...InternalUserData
      }
    }
  }
  developments {
    id
    name
  }
  projects {
    id
    name
  }
  availableFeatureFlagTypes(all: $all) {
    code
    name
    description
    presentational
  }
}
    ${InternalUserDataFragmentDoc}`;

/**
 * __useFeatureFlagsMetadataQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsMetadataQuery({
 *   variables: {
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFeatureFlagsMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>(FeatureFlagsMetadataDocument, options);
      }
export function useFeatureFlagsMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>(FeatureFlagsMetadataDocument, options);
        }
// @ts-ignore
export function useFeatureFlagsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>;
export function useFeatureFlagsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureFlagsMetadataQuery | undefined, FeatureFlagsMetadataQueryVariables>;
export function useFeatureFlagsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>(FeatureFlagsMetadataDocument, options);
        }
export type FeatureFlagsMetadataQueryHookResult = ReturnType<typeof useFeatureFlagsMetadataQuery>;
export type FeatureFlagsMetadataLazyQueryHookResult = ReturnType<typeof useFeatureFlagsMetadataLazyQuery>;
export type FeatureFlagsMetadataSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagsMetadataSuspenseQuery>;
export type FeatureFlagsMetadataQueryResult = Apollo.QueryResult<FeatureFlagsMetadataQuery, FeatureFlagsMetadataQueryVariables>;
export const SaveFeatureFlagDocument = gql`
    mutation SaveFeatureFlag($input: SaveFeatureFlagInput!) {
  saveFeatureFlag(input: $input) {
    featureFlag {
      ...FeatureFlagDetails
    }
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;
export type SaveFeatureFlagMutationFn = Apollo.MutationFunction<SaveFeatureFlagMutation, SaveFeatureFlagMutationVariables>;

/**
 * __useSaveFeatureFlagMutation__
 *
 * To run a mutation, you first call `useSaveFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFeatureFlagMutation, { data, loading, error }] = useSaveFeatureFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFeatureFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFeatureFlagMutation, SaveFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFeatureFlagMutation, SaveFeatureFlagMutationVariables>(SaveFeatureFlagDocument, options);
      }
export type SaveFeatureFlagMutationHookResult = ReturnType<typeof useSaveFeatureFlagMutation>;
export type SaveFeatureFlagMutationResult = Apollo.MutationResult<SaveFeatureFlagMutation>;
export type SaveFeatureFlagMutationOptions = Apollo.BaseMutationOptions<SaveFeatureFlagMutation, SaveFeatureFlagMutationVariables>;